// extracted by mini-css-extract-plugin
export default {"page":"RegisterPage_page__BBI0Z","limit":"RegisterPage_limit__iVYWR","title":"RegisterPage_title__QeXWu","loginLink":"RegisterPage_loginLink__G4DBO"};